<ng-content select="sb-accordion-header"></ng-content>
<div
  [@contentExpand]="animationState()"
  [class.sb-animating]="isAnimating()"
  role="region"
  [id]="contentId()"
  [attr.aria-labelledby]="headerId()"
  (@contentExpand.start)="animationStarted()"
  (@contentExpand.done)="animationDone()"
>
  <div [attr.tabindex]="expanded() ? null : -1" [attr.inert]="!expanded() || null">
    <ng-content></ng-content>
  </div>
</div>
